import React, { useMemo } from 'react';
import classnames from 'classnames';
import { isNull } from 'lodash';
import DayJs from 'utils/Dayjs';

import Show from 'components/Show';
import Mark from 'components/Ui/Mark';
import Tooltip from 'components/Ui/Tooltip';

import { useStudentMarkStore } from 'store/student/useStudentMarkStore';

const Course = ({ course }) => {
	// Use student's mark store
	const takes = useStudentMarkStore(state => state.takes.filter(take => take.courseId === course.id).sort((a, b) => a.id - b.id));

	// Find last take
	const take = useMemo(() => {
		return takes?.[0] ?? {};
	}, [takes]);

	// Get mark's type
	const type = useMemo(() => ({
		unavailable: take.state === 'assigned' && DayJs().isBefore(take.startDate),
		active: take.state === 'active',
		finished: take.state === 'finished',
		reviewed: take.state === 'reviewed',
		transfered: take.state === 'reviewed' && isNull(take.startedAt),
		overdue: take.state === 'assigned' && DayJs().isAfter(take.endDate),
		failed: take.state === 'reviewed' && take.mark !== 0 && take.mark < 4
	}), [take]);

	// Get mark's style
	const style = classnames(
		type.active && 'text-neutral-700 border-sky-500 dark:text-neutral-200 dark:border-sky-500 after:absolute after:w-5 after:h-5 after:rounded-md after:border after:border-sky-500 after:animate-ping',
		type.finished && 'text-neutral-700 border-amber-500 dark:text-neutral-200 dark:border-amber-500',
		type.reviewed && 'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500',
		type.transfered && 'text-neutral-700 border-emerald-500 dark:text-neutral-200 dark:border-emerald-500',
		type.overdue && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500 text-xs',
		type.failed && 'text-rose-500 border-rose-500 dark:text-rose-500 dark:border-rose-500',
		(!type.active && !type.finished && !type.reviewed && !type.transfered && !type.overdue && !type.failed)
		&& 'text-neutral-700 border-neutral-200 dark:text-neutral-200 dark:border-neutral-500'
	);

	// Do not render empty take
	if (!take.id) return null;

	return (
		<Tooltip content={() =>
			<div className="py-1 px-2 bg-white text-neutral-700 whitespace-nowrap rounded-lg">
				<div className="text-sm font-bold text-neutral-700">
					{take?.exam?.title}
				</div>

				<div className="text-sm font-normal text-neutral-500">
					{DayJs(take.startDate).format('D. MMM, YYYY')} - {DayJs(take.endDate).format('D. MMM, YYYY')}
				</div>

				<Show if={type.transfered}>
					<div className="mt-2 text-emerald-500">
						Pārcelts vērtējums
					</div>
				</Show>
			</div>
		}>
			<Mark
				to={(type.transfered || type.unavailable) ? '' : `/exams/${take.id}`}
				type={type}
				mark={type?.overdue ? 'nv' : take?.mark}
				className={style}
			/>
		</Tooltip>
	);
};

export default Course;